<template>
  <div>
    <div class="d-flex align-center">
      <v-avatar class="ma-1"
        ><v-img v-if="cast_data.image" :src="setting.cdn + cast_data.image"
      /></v-avatar>
      <div class="ml-4">
        <div class="d-flex align-center">
          <span class="font-weight-bold">{{ cast_data.name }}</span>
          <span v-if="cast_data.age" class="ml-2">{{ cast_data.age }}歳</span>
          <span class="ml-2 router-push" @click="onClickEdit"
            >新規タブで開く</span
          >
        </div>
        <div v-if="cast_data.catch_copy">
          {{ cast_data.catch_copy }}
        </div>
        <div class="d-flex flex-wrap">
          <div
            v-if="
              cast_data.tall ||
              cast_data.bust ||
              cast_data.cup ||
              cast_data.waist ||
              cast_data.hip
            "
            class="mr-2"
          >
            {{ cast_data.tall ? "H:" + cast_data.tall + " " : ""
            }}{{ cast_data.bust ? "B:" + cast_data.bust + " " : ""
            }}{{ cast_data.cup ? "(" + cast_data.cup + ") " : ""
            }}{{ cast_data.waist ? "W:" + cast_data.waist + " " : ""
            }}{{ cast_data.hip ? "H:" + cast_data.hip : "" }}
          </div>
          <div v-if="cast_data.blood_type" class="mr-2">
            {{
              (
                selectItem.bloodTypeItem.find(
                  (item) => item.value == cast_data.blood_type
                ) || {}
              ).text + "型" || ""
            }}
          </div>
          <div v-if="cast_data.sign" class="mr-2">
            {{
              (
                selectItem.signItem.find(
                  (item) => item.value == cast_data.sign
                ) || {}
              ).text || ""
            }}
          </div>
          <div v-if="cast_data.style" class="mr-2">
            スタイル:
            {{
              (
                selectItem.styleItem.find(
                  (item) => item.value == cast_data.style
                ) || {}
              ).text || ""
            }}
          </div>
          <div v-if="cast_data.type" class="mr-2">
            タイプ:
            {{
              (
                selectItem.typeItem.find(
                  (item) => item.value == cast_data.type
                ) || {}
              ).text || ""
            }}
          </div>
          <div v-if="cast_data.entry_date" class="mr-2">
            入店:
            {{ cast_data.entry_date.replace(/-/g, "/") }}
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { reactive, toRefs, defineComponent } from "@vue/composition-api";
import setting from "@/common/setting.js";
import selectItem from "@/common/selectItem";
import { useRouter } from "@/utils";

export default defineComponent({
  props: ["cast_data"],
  setup(props, ctx) {
    const { router } = useRouter();
    const state = reactive({});

    // 編集画面に移動（新しいタブで開く）
    const onClickEdit = () => {
      const url = router.resolve({
        name: "cast-edit",
        params: { cast_id: props.cast_data.id },
        query: { tab: "comment" },
      }).href;
      window.open(url, "_blank");
    };

    return {
      props,
      setting,
      selectItem,
      ...toRefs(state),
      onClickEdit,
    };
  },
});
</script>

<style scoped>
.router-push {
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
}
</style>
